 import en_US from "locale/en_US";
import zh_CN from "locale/zh_CN";
import React from 'react';
import {addLocaleData, IntlProvider} from "react-intl";
import en from "react-intl/locale-data/en";
import zh from "react-intl/locale-data/zh";
import { connect } from 'react-redux';
import {Button, ConfigProvider, Modal,message} from 'antd';
import ant_zh from 'antd/lib/locale-provider/zh_CN';
import ant_en from 'antd/lib/locale-provider/en_US';
import axios from "axios"


addLocaleData([...en, ...zh]);

import 'style/main.css';
import 'style/main.less';
import LoginWithMobileModal from "../../scenes/UserService/Login/LoginWithMobileModal";
import {withRouter} from "react-router-dom";
 import {
  LOGIN,
  NETWORK_ERROR,
  RESET_AUTHENTICATION_EXPIRED,
  RESET_NETWORK_ERROR
} from "reducers/authenticationNew";

class App extends React.PureComponent {

  componentWillReceiveProps(nextProps){
    if(nextProps.isAuthenticated!==this.props.isAuthenticated&&nextProps.isAuthenticated===true){
      // this.inactivityTime()
      // this.countTime(nextProps.isAuthenticated);
    }
  }


//   clickPlatform=()=>{
//     if(this.props.isAuthenticated){
//       console.log("上次访问时间：",this.props.visitTime);
//       if(this.props.visitTime){
//         console.log("点击了平台");
//         let timeOut=30*60*1000;
//         let currentTime = new Date().getTime();
//         if(currentTime - this.props.visitTime > timeOut){
//           console.log("访问超时");
//           console.log("上次访问时间：",this.props.visitTime,"登出时间：",this.props.visitTime+timeOut);
//           let url = "/time-out";
//           axios({
//             method: "post",
//             url: url,
//             contentType: "application/json",
//             withCredentials: true,
//             data: {
//               logoutTime:this.props.visitTime+timeOut
//             }
//           }).then(
//             response => {
//               console.log(response.data);
//               if(response.data==="authentication/LOGIN_TIME_OUT"){
//                 this.props.onTimeOutVisible()
//               }
//             });
//           // axios.get(url, {contentType: "application/json"}).then(
//           //   response => {
//           //     console.log(response.data);
//           //     if(response.data==="authentication/LOGIN_TIME_OUT"){
//           //       this.props.onTimeOutVisible()
//           //     }
//           //   })
//         }else{
//           this.props.updateVisitTime()
//         }
//       }else {
//         //状态中访问时间为null时给赋值
//         this.props.updateVisitTime()
//       }
//     }
//   };
//
//   inactivityTime = (logout=this.logout)=> {
//   let time;
//   window.onload = resetTimer;
//   // DOM Events
//   document.onmousemove = resetTimer;
//   document.onkeypress = resetTimer;
//
//   function resetTimer(isAuthenticated=this.props.isAuthenticated) {
//     if(isAuthenticated){
//       console.log("重新计时");
//       clearTimeout(time);
//       window.localStorage.setItem('time',0);
//       time = setTimeout(logout, 10000)
//     }
//
//     // 1000 milliseconds = 1 second
//   }
// };

  // countTime=(isAuthenticated)=>{
  //   // if(isAuthenticated){
  //   window.localStorage.setItem('time',new Date().getTime());
  //   window.localStorage.setItem('timeOut',false);
  //     //Increment the idle time counter every minute.
  //     let idleInterval = setInterval(this.timerIncrement, 1000); // 1 second
  //
  //     //Zero the idle timer on mouse movement.
  //     document.onmousemove = function (e) {
  //       // idleTime = 0;
  //       window.localStorage.setItem('time',new Date().getTime());
  //     };
  //     document.onkeypress = function (e) {
  //       // idleTime = 0;
  //       window.localStorage.setItem('time',new Date().getTime());
  //
  //     };
  //   // }
  //
  // };

  // timerIncrement=()=> {
  //   if(this.props.isAuthenticated){
  //     let time  = parseInt(window.localStorage.getItem('time'));
  //     let currentTime = new Date().getTime();
  //     let gap = currentTime - time;
  //     // console.log("上次：",time,"差：",gap);
  //     // console.log("计时时间：",window.localStorage.getItem('time'));
  //     if (gap > 120*60*1000&&!this.props.isAuthenticationExpired) { // 30min
  //       this.logout()
  //     }
  //   }
  //
  // };

//   logout=()=> {
//   if(this.props.isAuthenticated){
//     window.localStorage.setItem('timeOut',true);
//     console.log("超时：",window.localStorage.getItem('timeOut'));
//   //   alert("You are now logged out.")
//     this.props.casLogout();
//     this.props.onTimeOutVisible();
//     // let url = "/time-out";
//     // axios({
//     //   method: "post",
//     //   url: url,
//     //   contentType: "application/json",
//     //   withCredentials: true,
//     //   data: {
//     //     logoutTime:new Date().getTime()
//     //   }
//     // }).then(
//     //   response => {
//     //     console.log(response.data);
//     //     if(response.data==="authentication/LOGIN_TIME_OUT"){
//     //       this.props.onTimeOutVisible()
//     //     }
//     //   });
//   }
//   //location.href = 'logout.html'
// };

  setModalContent=()=>{
    switch (this.props.loginError){
      case "login timeout":
        return "会话已过期，请重新登录";
        break;
      case "Query TGT failed":
        return "TGT已失效，请重新登录";
        break;
      case "Ip changed":
        return "IP地址已切换，请重新登录";
        break;
      default:
        return "您的登录状态已失效，请重新登录"
    }
  };

  //检查/api-me/访问是否正常
   checkRequest=()=>{
     this.props.resetNetworkError();
     setTimeout(() => {
       axios.get('/api-me/').catch((e) => {
         this.props.networkError();
       })
     }, 60000);
   };

  render() {
    let localeStr = this.props.currentLocale === "en" ? "en" : "zh";
    let messagesRef = this.props.currentLocale === "en" ? en_US : zh_CN;
    let antLocale= this.props.currentLocale === "en" ? ant_en : ant_zh;

    // Modal.info({
    //   title: '登录信息已失效',
    //   content: (
    //     <div>
    //       <p>您的登录信息已失效，请重新登录</p>
    //     </div>
    //   ),
    //   onOk:()=>{
    //
    //   },
    // })
    const warning = () => {
      message.warning({
        content: '您的网络已失去连接，请检查网络!',
        onClose:this.checkRequest
      });
    };

    return (
      <ConfigProvider locale={antLocale}>
        <IntlProvider locale={localeStr}
                      messages={messagesRef}>
          <div>
            <Modal
              visible={this.props.isAuthenticationExpired}
              title={"登录信息已失效"}
              closable={false}
              footer={[
                <Button type="primary" key="okBtn" onClick={()=>{
                  this.props.onModalOk();
                  {/*this.validateTimeOut()*/}
                }}>
                  确定
                </Button>,
              ]}
            >
              <p>{this.setModalContent()}</p>
            </Modal>

            <LoginWithMobileModal
              history={this.props.history}
              reset={this.props.reset}
              modalVisible = {this.props.isAlreadyLoginSomewhere}
            />
            {/*<Modal*/}
            {/*  visible={this.props.isNetworkError}*/}
            {/*  title={"用户信息请求失败"}*/}
            {/*  closable={false}*/}
            {/*  mask={false}*/}
            {/*  footer={[*/}
            {/*    <Button type="primary" key="okBtn" onClick={()=>{*/}
            {/*      /!*this.props.onModalOk();*!/*/}
            {/*      /!*this.validateTimeOut()*!/*/}
            {/*      this.checkRequest();*/}
            {/*    }}>*/}
            {/*      确定*/}
            {/*    </Button>,*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <p>请检查网络，确保网络连接成功后，点击确定按钮</p>*/}
            {/*</Modal>*/}
            {this.props.isNetworkError&&warning()}

            {this.props.children}

          </div>
        </IntlProvider>
      </ConfigProvider >
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    onModalOk:()=>{
      dispatch({type: RESET_AUTHENTICATION_EXPIRED});
      dispatch({type:LOGIN});
    },
    //TODO: 被已注释代码使用，暂注释清除
    // onTimeOutVisible:()=>{
    //   dispatch({type: LOGIN_TIME_OUT});
    //   dispatch({type: AUTHENTICATION_EXPIRED});
    // },
    // onTimeOutOk:()=>{
    //   dispatch({type: RESET_LOGIN_TIME_OUT});
    //   dispatch({type:CASLOGIN,forced:true});
    // },
    reset:()=>{
      dispatch({type: RESET_AUTHENTICATION_EXPIRED});
    },
    // updateVisitTime:()=>{
    //   dispatch({type:UPDATE_VISIT_TIME})
    // },
    // casLogout:()=>{
    //   dispatch({type: LOGOUT});
    // },
    resetNetworkError: () => {
      dispatch({type: RESET_NETWORK_ERROR});
    },
    networkError: () => {
      dispatch({type: NETWORK_ERROR});
    }
    // setLoginErrorInfo:(data)=>{
    //   dispatch({type: LOGIN_ERROR, data: data});
    //   dispatch({type:AUTHENTICATION_EXPIRED})
    // }
  };
};

export default withRouter(connect(
  state => ({
    currentLocale: state.locale.currentLocale,
    isAuthenticationExpired: state.authentication.isAuthenticationExpired,
    isAlreadyLoginSomewhere: state.authentication.isAlreadyLoginSomewhere,
    //TODO:已注释代码在使用如下两行，在重做authentication时暂定注释相应属性
    // visitTime:state.authentication.visitTime,
    // loginTimeOut:state.authentication.loginTimeOut,
    isAuthenticated: state.authentication.isAuthenticated,
    loginError:state.authentication.loginError,
    isNetworkError:state.authentication.isNetworkError,
    username:state.authentication.username,
  }),
  mapDispatchToProps
)(App));
